var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-fields search-fields--price-overview-fields" },
    [
      _c(
        "div",
        { staticClass: "search-field search-dates" },
        [
          _c("input-field", {
            ref: "travelDates",
            attrs: {
              name: _vm.translations.travel_dates,
              readonly: true,
              "icon-type": "calendar",
              value: _vm.dateString,
              error: _vm.validation.fromDate || _vm.validation.toDate
            },
            on: {
              focus: function($event) {
                _vm.showSelector = "calendar"
                _vm.dateSelection = "FROM_DATE"
              }
            }
          }),
          _vm._v(" "),
          _vm.showSelector == "calendar"
            ? _c("skov-range-picker", {
                attrs: { showDateInputs: false, value: _vm.initRange },
                on: { close: _vm.closeCalendar, input: _vm.selectDates }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-field search-field--travelers" },
        [
          _c("input-field", {
            attrs: {
              name: _vm.translations.number_of_travelers,
              value: _vm.numberOfTravelers,
              readonly: true,
              "icon-type": "travelers",
              error: _vm.validation.adults || _vm.validation.children
            },
            on: {
              focus: function($event) {
                _vm.showSelector = "travelers"
              }
            }
          }),
          _vm._v(" "),
          _vm.showSelector == "travelers"
            ? _c(
                "modal",
                {
                  attrs: {
                    title: _vm.translations.number_of_travelers,
                    "close-on-click": true,
                    "is-open": _vm.openModal == "travelers"
                  },
                  on: {
                    close: function($event) {
                      _vm.showSelector = null
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      slot: "icon",
                      src: require("../../../../../assets/img/icons/icon-persons.svg"),
                      alt: ""
                    },
                    slot: "icon"
                  }),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass: "modal-view-list modal-view-list--no-hover"
                    },
                    [
                      _c(
                        "li",
                        { staticClass: "modal-view-list__item" },
                        [
                          _c("span", {
                            staticClass: "modal-view-list__item__text",
                            domProps: {
                              textContent: _vm._s(
                                _vm.translations.number_of_adults
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("count-picker", {
                            attrs: { max: 4, min: 0 },
                            model: {
                              value: _vm.form.adults,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "adults", $$v)
                              },
                              expression: "form.adults"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "modal-view-list__item" },
                        [
                          _c("span", {
                            staticClass: "modal-view-list__item__text",
                            domProps: {
                              textContent: _vm._s(
                                _vm.translations.number_of_children
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("count-picker", {
                            attrs: { min: 0, max: 4 },
                            model: {
                              value: _vm.form.childrenCount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "childrenCount", $$v)
                              },
                              expression: "form.childrenCount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.form.children, function(val, key) {
                        return _c(
                          "li",
                          { key: key, staticClass: "modal-view-list__item" },
                          [
                            _c("span", {
                              staticClass: "modal-view-list__item__text",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.translations.children_ages.replace(
                                    /{n}/,
                                    key + 1
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("count-picker", {
                              attrs: { min: 0, max: _vm.maxChildrenAge },
                              model: {
                                value: _vm.form.children[key],
                                callback: function($$v) {
                                  _vm.$set(_vm.form.children, key, $$v)
                                },
                                expression: "form.children[key]"
                              }
                            })
                          ],
                          1
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "modal-view__footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c("button", {
                        staticClass: "btn btn--success",
                        domProps: {
                          textContent: _vm._s(_vm.translations.ok_btn)
                        },
                        on: {
                          click: function($event) {
                            _vm.showSelector = null
                          }
                        }
                      })
                    ]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-with-icon btn--positive search-fields__btn",
          attrs: { disabled: _vm.validForm },
          on: { click: _vm.search }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 19.95 19.95"
              }
            },
            [
              _c("path", {
                staticStyle: { fill: "#fff", "fill-rule": "evenodd" },
                attrs: {
                  d:
                    "m19.55,17.53l-3.77-3.77c.93-1.42,1.37-3.19,1.37-5.18,0-2.55-.72-4.74-2.28-6.3-1.56-1.55-3.75-2.28-6.3-2.28S3.83.72,2.28,2.28C.72,3.83,0,6.02,0,8.58s.72,4.74,2.28,6.3c1.56,1.55,3.75,2.28,6.3,2.28,1.99,0,3.76-.44,5.18-1.37l3.77,3.77c.27.26.63.4,1,.4.37,0,.73-.15,1-.42.26-.26.42-.62.42-1,0-.37-.14-.74-.4-1Zm-6.69-4.67c-.88.87-2.25,1.44-4.28,1.44s-3.4-.56-4.28-1.44-1.44-2.25-1.44-4.28.56-3.4,1.44-4.28c.87-.88,2.25-1.44,4.28-1.44s3.4.56,4.28,1.44c.87.87,1.44,2.25,1.44,4.28s-.56,3.4-1.44,4.28Z"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("span", {
            domProps: { textContent: _vm._s(_vm.translations.search) }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffef2bcc", { render: render, staticRenderFns: staticRenderFns })
  }
}